<template>
    <div id="warehouse-page" class="warehouse-page" v-if="isView">
        <van-pull-refresh v-model="loading" @refresh="init">
            <van-sticky :class="stickyClassName" style="font-size: 0; margin-bottom: -1px">
                <div class="search">
                    <form action="/">
                        <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="请输入关键词" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                        </van-search>
                    </form>
                </div>
            </van-sticky>
            <div class="top-tab-box" v-if="entrance == 'app'">
                <div class="ad-box" @click="toBrandList">
                    <div class="ad-top flex flex-between">
                        <img class="beauty-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/blsWarehouse/bls-logo.png" alt="" />
                        <div class="flex flex-x-center Greys font26 flex-y-center more-box">
                            <div class="flex-y-center">
                                品牌介绍
                                <img class="more-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/arrow-sck.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="ad-inner">
                        贝黎诗（PALAISPA），美丽田园集团旗下高端美容连锁品牌。成立于2005年。
                        贝黎诗引进全球先进美容理念，重视健康，回归自然。甄选安全、有效、特色的产品和护理疗程，打造五星级专业护理体验。
                    </div>
                </div>
            </div>
            <van-sticky :class="stickyClassName" :offset-top="`${entrance != 'sidebar' ? '1.35rem' : ''}`" @change="stickyChange" style="font-size: 0">
                <div class="list-tab-box">
                    <div>
                        <div class="flex flex-y-center">
                            <div class="list-tab flex flex-y-center">
                                <div :class="['list-tab-item', tabIndex == index ? 'active' : '']" v-for="(item, index) in tabList" :key="index" @click="changeTab(index, item)">
                                    {{ item.name }}
                                </div>
                            </div>
                            <img class="hint-icon" @click="viewRule" v-if="isSidebar" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/hint-icon.png" alt="" />
                        </div>
                        <div v-show="typeTabList.length > 0" class="type-tab flex flex-y-center">
                            <div :class="[
                                'type-tab-item',
                                typeTabIndex == oIndex ? 'active' : '',
                            ]" v-for="(oItem, oIndex) in typeTabList" :key="oIndex" @click="changeTypeTab(oIndex, oItem)">
                                {{ oItem.name }}
                            </div>
                        </div>
                        <div class="hint-txt" v-if="isSidebar">
                            一对一发送客户的素材，不可发朋友圈
                        </div>
                        <div class="dropdown-box flex-y-center flex-between" v-if="entrance == 'app'">
                            <van-dropdown-menu active-color="#35434C">
                                <van-dropdown-item :title="dropdownTitle" ref="mediumType" v-model="mediumType" :options="typeOption" @change="typeChange" />
                            </van-dropdown-menu>
                            <img class="hint-icon" @click="viewRule" v-if="!isSidebar" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/hint-icon.png" alt="" />
                        </div>
                    </div>
                </div>
            </van-sticky>
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList" v-if="list.length > 0">
                <div class="list-box">
                    <div :class="[
                        `${item.styleType == 1 ? 'list-item-vertical' : 'list-item'}`,
                        `${item.styleType == 1 && isSidebar ? 'h730' : ''}`,
                    ]" v-for="(item, index) in list" :key="index">
                        <div class="flex-col">
                            <img v-if="item.newMedium" src="@/assets/img/new-icon.png" alt="" class="new-icon" />
                            <div class="list-item-title">{{ item.title }}</div>
                            <div v-if="item.mediumTypeDesc" class="sign">
                                {{ item.mediumTypeDesc }}
                            </div>
                            <!-- ----------------素材内容start------------------ -->
                            <div v-for="(v, k) in item.contentArr" :key="k" :class="[
                                'preContentWrapper',
                                'flex',
                                'flex-col',
                                'flex-start',
                                `${v.type == 1 && item.styleType == 1 ? 'mb-18' : ''}`,
                            ]">
                                <div v-if="v.type == 1" class="whiteSpace" v-html="v.content.content" @click="toDetail(item.id)">
                                </div>
                                <div v-if="v.type == 2 && v.content.imageList.length != 0" class="imageBox" @click="toDetail(item.id)">
                                    <div :class="v.content.imageList.length == 1
                                        ? 'oneImg'
                                        : v.content.imageList.length == 2
                                            ? 'twoImg'
                                            : 'threeImg'
                                        " v-for="(oItem, oIndex) in v.content.imageList" :key="oIndex + 'image'">
                                        <img class="preViewImages" :src="oItem.url" alt="" />
                                        <img class="flag-img" v-if="v.content.isImgMark" src="@/assets/img/flag-icon.png" alt="" />
                                        <div class="flag-num" v-if="v.content.isImgMark">
                                            {{ oIndex + 1 }}
                                        </div>
                                        <div class="send-img-btn" v-if="
                                            isSidebar &&
                                            v.type == 2 &&
                                            item.styleType != 1 &&
                                            (isSend || mediumGroupId == 1)
                                        " @click.stop="sendMessage(item.id, v, k, oIndex)">
                                            发送
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="v.type == 2 && v.content.imageList.length == 0" class="imageBox" @click="toDetail(item.id)">
                                    <div class="white-box">
                                        <!-- //占位 -->
                                    </div>
                                </div>
                                <div v-if="v.type == 3 && v.content.imageList.length > 0" class="wordAndImage" @click="toDetail(item.id)">
                                    <div>
                                        <img v-for="(item, index) in v.content.imageList" :key="index + 'word_image'" :src="item.url" alt="" />
                                        <div class="wordWrapper">
                                            <div class="title">{{ v.content.textTitle }}</div>
                                            <div class="desc">{{ v.content.textDesc }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="v.type == 4 && v.content.audioList.length > 0" class="audioImage" @click="toDetail(item.id)">
                                    <div>
                                        <img class="file-icon" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/media-icon-sck.png" />
                                        <div class="title flex-1">
                                            {{ v.content.audioList[0].name }}
                                        </div>
                                        <div class="size">
                                            文件大小 {{ v.content.audioList[0].sizeDesc }}
                                        </div>
                                    </div>
                                </div>
                                <div v-if="v.type == 5 && v.content.videoList.length > 0" class="videoWrapper" @click="toDetail(item.id)">
                                    <div class="videoBox">
                                        <!-- <video controls :src="v.content.videoList[0].url" :poster="v.content.videoPoster"></video> -->
                                        <img class="video-img" :src="v.content.videoPoster" alt="" />
                                        <img class="player-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/player-icon.png" alt="" />
                                    </div>
                                </div>
                                <div v-if="v.type == 6 && v.content.imageList.length > 0" class="appWrapper" @click="toDetail(item.id)">
                                    <div class="header">
                                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/logo-sck-xs.png" alt="" />
                                        <span>美丽田园</span>
                                    </div>
                                    <div class="Blacks font32">{{ v.content.appTitle }}</div>
                                    <div class="mainImg">
                                        <img v-for="(item, index) in v.content.imageList" :key="index + 'app_image'" :src="item.url" alt="" />
                                    </div>
                                    <div class="footer">
                                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/wx-link-sck.png" alt="" />
                                        <span>小程序</span>
                                    </div>
                                </div>
                                <div v-if="v.type == 7 && v.content.filesList.length > 0" class="filesWrapper" @click="toDetail(item.id)">
                                    <div v-for="(item, index) in v.content.filesList" :key="index + 'files_wrapper flex-between '">
                                        <img src="@/assets/img/files.png" class="file-icon" alt="" />
                                        <div class="title flex-1">{{ item.name }}</div>
                                        <div class="size">文件大小 {{ item.sizeDesc }}</div>
                                    </div>
                                </div>
                                <!-- ---------------侧边栏按钮显示逻辑 ⬇------------------ -->
                                <!-- 一对一分组 按钮 非竖版 -->
                                <div class="flex flex-end" v-if="
                                    isSidebar &&
                                    mediumGroupId == 1 &&
                                    v.type != 2 &&
                                    item.styleType != 1
                                ">
                                    <div class="edit-send-btn" v-if="v.type == 1" @click="copyText(v.content.content)">
                                        复制文案
                                    </div>
                                    <div class="send-btn" v-if="v.type == 1" @click="modifyText(v.content.content)">
                                        修改发送
                                    </div>
                                    <div class="send-btn" @click.stop="sendMessage(item.id, v, k)">
                                        发送
                                    </div>
                                </div>
                                <!-- 一对一分组 按钮 竖版 -->
                                <div class="flex flex-end" v-if="
                                    isSidebar &&
                                    mediumGroupId == 1 &&
                                    v.type != 2 &&
                                    item.styleType == 1 &&
                                    v.content.content != ''
                                ">
                                    <div class="edit-send-btn" v-if="v.type == 1" @click="copyText(v.content.content)">
                                        复制
                                    </div>
                                    <div class="send-btn" v-if="v.type == 1" @click="modifyText(v.content.content)">
                                        修改
                                    </div>
                                    <div class="send-btn" @click.stop="sendMessage(item.id, v, k)">
                                        发送
                                    </div>
                                </div>
                                <div class="flex flex-end mt-30" v-if="
                                    isSidebar &&
                                    mediumGroupId == 1 &&
                                    item.styleType == 1 &&
                                    v.type == 2
                                ">
                                    <div v-if="v.content.imageList.length != 0" :class="[
                                        'send-big-btn',
                                        `${item.styleType == 1 ? 'w261' : ''}`,
                                    ]" @click.stop="sendMessage(item.id, v, k, 0)">
                                        发送
                                    </div>
                                </div>
                                <!-- 朋友圈分组按钮 -->
                                <div class="flex flex-end" v-if="isSidebar && mediumGroupId == 2">
                                    <div v-if="isSend && item.styleType != 1" class="edit-send-btn w160" @click="changeSendType()">
                                        发朋友圈
                                    </div>
                                    <div v-if="
                                        isSend && item.styleType == 1 && v.content.content != ''
                                    " class="edit-send-btn w160" @click="changeSendType()">
                                        朋友圈
                                    </div>
                                    <div v-if="!isSend && item.styleType != 1" class="edit-send-btn w160" @click="changeSendType()">
                                        一对一发送
                                    </div>
                                    <div v-if="
                                        !isSend && item.styleType == 1 && v.content.content != ''
                                    " class="edit-send-btn w160" @click="changeSendType()">
                                        一对一
                                    </div>
                                    <div :class="`${isSend ? 'send-btn' : 'edit-send-btn'}`" v-if="v.type == 1 && isSend && v.content.content != ''" @click="modifyText(v.content.content)">
                                        修改发送
                                    </div>
                                    <div v-if="isSend && v.type != 2 && v.type != 1" class="send-btn" @click.stop="sendMessage(item.id, v, k)">
                                        发送
                                    </div>
                                    <div v-if="isSend && v.type == 1 && v.content.content != ''" class="send-btn" @click.stop="sendMessage(item.id, v, k)">
                                        发送
                                    </div>
                                    <div class="send-btn w160" v-if="
                                        v.type == 2 &&
                                        !isSend &&
                                        v.content.imageList.length != 0 &&
                                        item.styleType != 1
                                    " @click="toDetail(item.id)">
                                        保存图片
                                    </div>
                                    <div class="send-btn w160" v-if="v.type == 1 && !isSend && v.content.content != ''" @click="copyText(v.content.content)">
                                        复制文案
                                    </div>
                                </div>
                                <!-- 朋友圈--竖版--图片--分组按钮 -->
                                <div class="flex flex-end mt-30" v-if="
                                    isSidebar &&
                                    mediumGroupId == 2 &&
                                    item.styleType == 1 &&
                                    v.type == 2
                                ">
                                    <div v-if="isSend && v.content.imageList.length != 0" :class="[
                                        'send-big-btn',
                                        `${item.styleType == 1 ? 'w261' : ''}`,
                                    ]" @click.stop="sendMessage(item.id, v, k, 0)">
                                        发送
                                    </div>
                                    <div :class="[
                                        'send-big-btn',
                                        `${item.styleType == 1 ? 'w261' : ''}`,
                                    ]" v-if="!isSend && v.content.imageList.length != 0" @click="toDetail(item.id)">
                                        保存图片
                                    </div>
                                </div>

                                <!-- ----------------应用按钮显示逻辑 ⬇------------------ -->

                                <div class="flex flex-end" v-if="!isSidebar && item.mediumGroupType != 1">
                                    <div class="send-btn w160" v-if="
                                        v.type == 2 && !isSend && v.content.imageList.length != 0
                                    " @click="toDetail(item.id)">
                                        保存图片
                                    </div>
                                    <div class="send-btn w160" v-if="v.type == 1 && !isSend && v.content.content != ''" @click="copyText(v.content.content)">
                                        复制文案
                                    </div>
                                </div>
                            </div>
                            <div v-if="!isSidebar && item.mediumGroupType == 1" class="group-send">
                                <div :class="[
                                    'send-big-btn',
                                    `${item.styleType == 1 ? 'w261' : ''}`,
                                ]" @click="sendGroupMsg(item.id)">
                                    发送
                                </div>
                            </div>
                            <!-- ----------------素材内容end------------------ -->
                        </div>
                    </div>
                </div>
            </van-list>
            <div class="empty" v-else>
                <van-empty image="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/sck-empty.png" :description="emptyMsg" />
            </div>
            <van-popup class="definition-popup-box" v-model="ruleShow" closeable close-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-07/close.png">
                <div class="definition-show-box">
                    <div class="definition-head">素材发送说明</div>
                    <div class="definition-content">
                        <div class="definition-name-box flex-col">
                            <div class="flex-start flex-y-center mb-20">
                                <div class="dot"></div>
                                <div class="definition-title">侧边栏-素材库（一对一发送）</div>
                            </div>
                            <div class="definition-name">
                                不限发送次数；一个素材中有多个内容，每个内容需要单独发送.
                            </div>
                            <div class="flex-start flex-y-center mb-20">
                                <div class="dot"></div>
                                <div class="definition-title">应用-素材库：</div>
                            </div>
                            <div class="definition-name">
                                限制发送次数；每个客户每天仅限接收一条素材（素材中多个内容支持一键发送）；
                                <br />
                                且只有【重点项目】中的素材支持发送，其他分类中的素材可以保存下载。
                            </div>
                            <div class="definition-name" style="margin-top: 10px">
                                注：发送企微朋友圈<br />
                                需要将图片保存至相册、复制文案后，再发送朋友圈。
                            </div>
                        </div>
                    </div>
                </div>
            </van-popup>
            <editSend ref="editSend" />
            <div v-if="isExpand" class="contact-box flex-col flex-y-center flex-between">
                <div class="wechat flex-col flex-y-center" @click="changeUrl(1)">
                    <img referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/smsck-icon.png" class="icon-item chat-icon" alt="" />
                    <div class="contact-name active">生美</div>
                </div>
                <div class="make-call flex-col flex-y-center" @click="changeUrl(2)">
                    <img referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/ymsck-icon.png" class="icon-item" alt="" />
                    <div class="contact-name">医美</div>
                </div>
                <div class="make-call flex-col flex-y-center" @click="changeUrl(3)">
                    <img referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/kssck-icon.png" class="icon-item" alt="" />
                    <div class="contact-name">抗衰</div>
                </div>
                <div class="icon-arrow flex-1 flex-end flex-y-center" @click="openChangeUrl(false)">
                    <img referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/sck-down-icon.png" class="icon-item" alt="" />
                </div>
            </div>
            <div v-else class="chat-box flex-x-center flex-y-center" @click="openChangeUrl(true)">
                <img referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/sck-up-icon.png" class="icon-item" alt="" />
            </div>
        </van-pull-refresh>
    </div>
</template>

<script type="text/javascript" src="//res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>
<script>
import {
    Toast,
    Tabbar,
    TabbarItem,
    Divider,
    Empty,
    ImagePreview,
    PullRefresh,
} from "vant";
import request from "@/utils/request";
import { getCookie } from "@/utils";
import editSend from "./components/editSend";
import { convertToAttachmentContent } from "@/utils/media";
import { keepAliveAfterHandler } from "@/router/router";
import {
    getContext,
    getCurExternalContact,
    previewFile,
    sendChatMessage,
    shareToExternalContact,
} from "@/utils/wxCodeAuth";
import _ from "lodash";

export default {
    name: "blsWarehouse",
    components: {
        Tabbar,
        editSend,
        TabbarItem,
        Divider,
        Empty,
        ImagePreview,
        PullRefresh,
    },
    beforeRouteLeave(to, from, next) {
        keepAliveAfterHandler.call(this, to, from);
        const pageDom = this.getPageDom();
        this.$route.meta.scrollTop = pageDom.scrollTop;
        next();
    },
    computed: {
        typeTabList() {
            if (!this.tabList.length > 0 || this.tabIndex === -1) {
                return [];
            }
            return this.tabList[this.tabIndex].mediumGroupList ?? [];
        },
        stickyClassName() {
            return this.isSidebar ? "no-fixed" : this.isFixed ? "is-fixed" : "";
        },
        isSidebar() {
            return this.entrance == "sidebar";
        },
    },
    data() {
        return {
            isView: false,
            entrance: "", // 素材库入口
            searchStr: "", //搜索
            ruleShow: false, //定义说明
            tabList: [], // 大类tab
            tabIndex: -1, //大类下标
            typeTabIndex: 0, //小类下标
            mediumParentGroupId: 0, //大类id
            mediumGroupId: 0, // 小类id
            page: 1,
            total: 0,
            loading: false, // 加载
            finished: false, // 结束加载
            refreshing: false, // 刷新
            mediumType: 0, //筛选状态
            typeOption: [
                { text: "全部", value: 0 },
                { text: "仅限一对一发送", value: 1 },
                { text: "朋友圈/一对一", value: 2 },
            ],
            dropdownTitle: "", //下拉筛选
            list: [], //素材列表
            isFixed: false, //是否粘性布局
            share: {
                type: "",
                contentData: "",
            },
            userId: "", // 外部联系人id
            isSend: false,
            emptyMsg: "",
            isExpand: true, //是否展开切换
            empNo: "", //工号
        };
    },
    activated() {
        // 在页面被缓存后重新激活时调用
        const pageDom = this.getPageDom();
        pageDom.scrollTo(0, this.$route.meta.scrollTop || 0);
    },
    created() {
        this.empNo = localStorage.getItem("empNo") || getCookie("empNo");
        this.init();
    },
    methods: {
        getPageDom() {
            return document.getElementById("warehouse-page");
        },
        init() {
            this.judgeCustId();
        },
        //员工基本信息
        getUserLogin() {
            return request({
                url: "/my/getUserLogin",
                method: "get",
            })
                .then((res) => {
                    this.empNo = res.data.empNo;
                })
                .catch((error) => {
                    Toast({ position: "top", message: error ?? "" });
                });
        },
        // 判断是侧边栏还是应用
        async judgeCustId() {
            if (this.$route.query.entrance == "app") {
                this.entrance = "app";
                this.isView = true;
            } else {
                // this.entrance = "sidebar";
                // this.isView = true;
                // this.getGroupList();

                // return;

                // this.userId = await getCurExternalContact("");
                await getContext().then(async (entry) => {
                    if (entry === "single_chat_tools" || entry === "group_chat_tools") {
                        this.entrance = "sidebar";
                        await this.getUserLogin();//拿工号
                        await this.getSckUrl().then((res) => {
                            // 医美和抗衰人员进来直接跳去5G素材库
                            if (res.data.firstDeptId == 4) {
                                window.location.href = res.data.url_4 + "?userid=" + this.empNo;
                            } else if (res.data.firstDeptId == 5) {
                                window.location.href =
                                    res.data.url_5 + "?userid=" + this.empNo + "&type=ks";
                            }
                        });
                        this.isView = true;
                    }
                });
            }
            this.getGroupList();
        },
        // 获取分类
        getGroupList() {
            request({
                url: `/mediumGroup/index?queryType=${this.isSidebar ? 1 : 2}&groupId=`,
                method: "get",
            })
                .then((res) => {
                    this.tabList = res.data;
                    this.changeTab(0, this.tabList[0]);
                })
                .catch((error) => {
                    Toast({ position: "top", message: error ?? "" });
                });
        },
        // 获取列表
        getList() {
            if (!this.isSidebar) {
                this.mediumParentGroupId = "";
            }
            request({
                url: `/medium/index?queryType=${this.isSidebar ? 1 : 2}&mediumType=${this.mediumType
                    }&limit=10&page=${this.page}&searchStr=${this.searchStr
                    }&mediumGroupId=${this.mediumGroupId}&mediumParentGroupId=${this.mediumParentGroupId
                    }`,
                method: "get",
            })
                .then((res) => {
                    this.list =
                        this.page == 1 ? res.data.list : this.list.concat(res.data.list);
                    this.page += 1;
                    this.total = res.data.total;
                })
                .catch((error) => {
                    this.finished = true;
                    Toast({ position: "top", message: error ?? "" });
                })
                .finally(() => {
                    this.loading = false;
                    if (this.list.length >= this.total) {
                        this.finished = true;
                    }
                });
        },
        // 获取mediaid
        getMediaId(id) {
            return request({
                url: `/medium/getMediaId?id=${id}&&queryType=${this.isSidebar ? 1 : 2}`,
                method: "get",
            });
        },
        // 获取素材库地址
        getSckUrl() {
            return request({
                url: `/user/getToken`,
                method: "post",
                data: {
                    username: this.empNo,
                },
            });
        },
        // 发送消息
        async sendMessage(id, item, index, imgIndex) {
            console.log(id, item, index, imgIndex);
            //获取临时文件id
            Toast.loading({
                message: "加载中...",
                forbidClick: true,
            });
            await this.getMediaId(id).then((res) => {
                Toast.clear();
                // 类型 1-文本、2-图片、3-图文、4-音频、5-视频、6-小程序、7-文件素材
                let contentArr = res.data.contentArr;
                switch (contentArr[index].type) {
                    case 1:
                        this.share.type = 1;
                        this.share.contentData = contentArr[index].content.content;
                        break;
                    case 2:
                        this.share.type = 2;
                        this.share.contentData =
                            contentArr[index].content.mediaIdList[imgIndex];
                        break;
                    case 3:
                        this.share.type = 3;
                        this.share.contentData = {
                            link: contentArr[index].content.textUrl,
                            title: contentArr[index].content.textTitle,
                            desc: contentArr[index].content.textDesc
                                ? contentArr[index].content.textDesc
                                : "",
                            imgUrl: contentArr[index].content.mediaIdList[0],
                        };
                        break;
                    case 4:
                        this.share.type = 7;
                        this.share.contentData = contentArr[index].content.mediaIdList[0];
                        break;
                    case 5:
                        this.share.type = 5;
                        this.share.contentData = contentArr[index].content.mediaIdList[0];
                        break;
                    case 7:
                        this.share.type = 7;
                        this.share.contentData = contentArr[index].content.mediaIdList[0];
                        break;
                    case 6:
                        this.share.type = 6;
                        this.share.contentData = {
                            appid: contentArr[index].content.appid,
                            title: contentArr[index].content.appTitle,
                            imgUrl: contentArr[index].content.imageList[0].url,
                            page: contentArr[index].content.appUrl,
                        };
                        break;
                }
            });
            sendChatMessage(this.share.type, this.share.contentData).then((res) => {
                //发送成功
                this.sendNum(id);
            });
        },
        //切换素材库
        openChangeUrl(val) {
            this.isExpand = val;
        },
        //跳转其他素材库
        changeUrl(num) {
            this.getSckUrl().then((res) => {
                if (num == 1) {
                    window.location.href = res.data.url_1 + "?entrance=" + this.entrance;
                } else if (num == 2) {
                    window.location.href =
                        res.data.url_4 +
                        "?userid=" +
                        this.empNo +
                        "&entrance=" +
                        this.entrance;
                } else if (num == 3) {
                    window.location.href =
                        res.data.url_5 +
                        "?userid=" +
                        this.empNo +
                        "&type=ks" +
                        "&entrance=" +
                        this.entrance;
                }
            });
        },
        // 群发
        async sendGroupMsg(id) {
            let attachments = [];
            let text;
            Toast.loading({
                message: "加载中...",
                forbidClick: true,
            });
            await this.getMediaId(id).then((res) => {
                Toast.clear();
                let contentArr = res.data.contentArr;
                contentArr.forEach((element) => {
                    switch (element.type) {
                        case 1:
                            text = element.content.content;
                            break;
                        case 2:
                            element.content.mediaIdList.forEach((item) => {
                                attachments.push({
                                    msgtype: "image",
                                    image: {
                                        mediaid: item, // 图片的素材id
                                        imgUrl: "", // 图片的imgUrl,跟图片mediaid填其中一个即可
                                    },
                                });
                            });

                            break;
                        case 3:
                            attachments.push({
                                msgtype: "link", // 消息类型，必填
                                link: {
                                    title: element.content.textTitle, // H5消息标题
                                    imgUrl: element.content.imageList[0].url, // H5消息封面图片URL
                                    desc: element.content.textDesc, // H5消息摘要
                                    url: element.content.textUrl, // H5消息页面url 必填
                                },
                            });
                            break;
                        case 4:
                            attachments.push({
                                msgtype: "file", // 消息类型，必填
                                file: {
                                    mediaid: element.content.mediaIdList[0], // 文件的素材id
                                },
                            });
                            break;
                        case 5:
                            attachments.push({
                                msgtype: "video", // 消息类型，必填
                                video: {
                                    mediaid: element.content.mediaIdList[0], // 视频的素材id
                                },
                            });
                            break;
                        case 6:
                            attachments.push({
                                msgtype: "miniprogram", // 消息类型，必填
                                miniprogram: {
                                    appid: element.content.appid, // 小程序的appid
                                    title: element.content.appTitle, // 小程序消息的title
                                    imgUrl: element.content.imageList[0].url, //小程序消息的封面图。必须带http或者https协议头
                                    page: element.content.appUrl, //小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
                                },
                            });
                            break;
                        case 7:
                            attachments.push({
                                msgtype: "file", // 消息类型，必填
                                file: {
                                    mediaid: element.content.mediaIdList[0], // 文件的素材id
                                },
                            });
                            break;
                    }
                });
            });
            shareToExternalContact(text, attachments.slice(0, 9)).then((res) => {
                this.sendGroupNum(id);
            });
        },
        // 单条发送回调统计发送次数
        sendNum(id) {
            request({
                url: `/medium/sendNumStatistic?id=${id}&wxExternalUserid=${this.empNo}`,
                method: "get",
            }).catch((error) => {
                Toast({ position: "top", message: error ?? "" });
            });
        },
        // 群发回调统计发送次数
        sendGroupNum(id) {
            request({
                url: `/medium/sendNumStatistic?id=${id}`,
                method: "get",
            }).catch((error) => {
                Toast({ position: "top", message: error ?? "" });
            });
        },
        // 修改发送
        modifyText(name) {
            this.$refs.editSend.show();
            this.$refs.editSend.msgs(name);
        },
        // 切换发送/朋友圈
        changeSendType() {
            this.isSend = !this.isSend;
        },
        // 跳转详情
        toDetail(id) {
            this.$router.push({ name: "warehouseDetail", query: { id } });
        },
        // 操作
        stickyChange(isFixed) {
            this.isFixed = isFixed;
        },
        changeTab(index, e) {
            this.tabIndex = index;
            this.mediumParentGroupId = e.id;
            this.list = [];
            this.changeTypeTab(0, e.mediumGroupList[0]);
            if (e.id == 1) {
                this.emptyMsg = "今日没有要发的任务哦 去其他分类看看吧~";
            } else {
                this.emptyMsg = "没有要发的任务哦 去其他分类看看吧~";
            }
        },
        changeTypeTab(index, e) {
            this.page = 1;
            this.finished = false;
            this.typeTabIndex = index;
            this.mediumGroupId = e.id;
            this.list = [];
            this.getList();
        },
        typeChange(num) {
            this.dropdownTitle = this.typeOption[num].text;
            this.page = 1;
            this.getList();
        },
        // 查询
        onSearch(e) {
            this.searchStr = e;
            this.page = 1;
            this.getList();
        },
        //清除搜索
        selClear() {
            this.searchStr = "";
            this.page = 1;
            this.getList();
        },
        //查看规则
        viewRule() {
            this.ruleShow = true;
        },
        // 去品牌介绍
        toBrandList() {
            this.$router.push({ name: "blsBrandList", query: {} });
        },
        copyText(text) {
            this.$copyText(text).then(
                function (e) {
                    Toast({ position: "top", message: "复制成功" });
                },
                function (e) {
                    Toast({ position: "top", message: "复制失败" });
                }
            );
        },
    },
};
</script>

<style scoped lang="less">
    .warehouse-page {
        height: 100%;
        overflow-y: auto;
        background-color: #f5f6f7;
    }

    .mt-30 {
        margin-top: 30px;
    }

    .is-fixed {
        .list-tab-box {
            background-color: #ffffff;
        }

        :deep(.van-sticky--fixed) {
            .search {
                background-color: #ffffff;
                padding-bottom: 1px;
                border-bottom: 1px solid #fff;
            }
        }
    }

    .no-fixed {
        :deep(.van-sticky--fixed) {
            position: static;
        }
    }

    :deep(.is-fixed .search .van-search .van-cell) {
        background-color: #f3f5f6 !important;
    }

    .search {
        padding: 34px 30px 1px 30px;
        background-color: #f5f6f7;
    }

    :deep(.van-sticky--fixed) {
        .search {
            padding-bottom: 40px;
        }
    }

    .top-tab-box {
        background-color: #f5f6f7;
        padding: 0 30px;
        margin-top: 40px;

        .ad-box {
            width: 690px;
            height: 326px;
            background: #ffffff;
            border-radius: 12px;
            padding: 30px;

            .beauty-icon {
                width: 104px;
                height: 40px;
            }

            .ad-inner {
                margin-top: 30px;
                width: 630px;
                height: 166px;
                color: #35434c;
                font-size: 28px;
            }

            .more-box {
                width: 146px;
                height: 48px;
                background: #ffdecc;
                border-radius: 24px;
                color: #ff5c00;
                font-size: 26px;

                .more-arrow {
                    width: 11px;
                    height: 17px;
                    margin-left: 8px;
                }
            }
        }
    }

    .list-tab-box {
        position: relative;
        padding: 0 30px;
        background-color: #f5f6f7;
        padding-top: 40px;

        .hint-icon {
            width: 30px;
            height: 30px;
            margin-left: 10px;
        }

        .hint-txt {
            font-size: 22px;
            font-weight: 400;
            color: #a0acb5;
            padding-top: 26px;
            padding-bottom: 30px;
        }

        .list-tab {
            width: 650px;
            height: 60px;
            overflow-x: scroll;
            overflow-y: hidden;
            white-space: nowrap;

            .list-tab-item {
                height: 42px;
                font-size: 30px;
                color: #a0acb5;
                line-height: 42px;
                margin-right: 52px;
                position: relative;
            }

            .list-tab-item.active {
                color: #35434c;
                font-weight: 700;
            }

            .list-tab-item.active:before {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: -10px;
                width: 40px;
                height: 4px;
                background: #37dbe0;
                margin: 0 auto;
                border-radius: 100px;
            }
        }

        .type-tab {
            width: 690px;
            overflow-x: scroll;
            white-space: nowrap;
            margin-top: 40px;
            padding: 1px;

            .type-tab-item {
                height: 50px;
                border-radius: 8px;
                font-size: 26px;
                font-weight: 400;
                line-height: 48px;
                margin-right: 20px;
                border: 1px solid transparent;
                background: #ffffff;
                color: #a0acb5;
                text-align: center;
                padding: 0 15px;
            }

            .type-tab-item.active {
                color: #ff5c00;
                border: 1px solid #ff5c00;
                background: rgba(255, 92, 0, 0.12);
            }
        }

        .dropdown-box {
            padding: 30px 0;
        }
    }

    .empty {
        background: #f5f6f7;
        padding-top: 80px;
    }

    .list-box {
        background: #f5f6f7;
        padding: 0 30px;
        padding-right: 0;

        .preViewImages {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            object-fit: cover;
        }

        .list-item {
            display: flex;
            flex-direction: column;
            background-color: #fff;
            margin-bottom: 20px;
            padding: 30px 30px 0 30px;
            position: relative;
            border-radius: 12px;
            margin-right: 30px;
        }

        .list-item-vertical {
            background-color: #fff;
            margin-bottom: 20px;
            padding: 30px 30px 0 30px;
            position: relative;
            border-radius: 12px;
            width: 336px;
            height: 730px;
            display: inline-block;
            vertical-align: top;
            margin-right: 18px;

            .list-item-title {
                width: 275px;
            }

            .oneImg {
                width: 276px;
                height: 379px !important;
            }

            .preViewImages {
                width: 276px;
                height: 379px;
            }
        }

        // .list-item-vertical.h730 {
        //     height: 730px;
        // }
        .list-item-title {
            font-size: 28px;
            font-weight: 700;
            color: #35434c;
            line-height: 40px;
            margin-bottom: 10px;
            width: 630px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .sign {
            position: absolute;
            top: 25px;
            right: 0;
            min-width: 92px;
            height: 40px;
            color: #fff;
            text-align: center;
            line-height: 40px;
            font-size: 24px;
            background: #ff5c00;
            border-radius: 7px 0px 0px 7px;
            padding: 0 10px;
        }

        .new-icon {
            width: 52px;
            height: 24px;
            margin-bottom: 10px;
        }

        .group-send {
            padding-bottom: 30px;
        }

        .send-big-btn {
            width: 290px;
            height: 70px;
            background: #2fd0d5;
            border-radius: 35px;
            line-height: 70px;
            text-align: center;
            color: #ffffff;
            font-size: 28px;
            margin: 0 auto;
        }

        .send-big-btn.w261 {
            width: 261px;
        }

        .preContentWrapper {
            padding-bottom: 30px;

            >div {}

            .edit-send-btn {
                width: 136px;
                height: 50px;
                background: #fff;
                border-radius: 25px;
                line-height: 48px;
                text-align: center;
                color: #a0acb5;
                font-size: 24px;
                margin-top: 30px;
                border: 1px solid #798a94;
                margin-left: 20px;
                padding-top: 1px;
            }

            .send-btn {
                width: 136px;
                height: 50px;
                background: #2fd0d5;
                border-radius: 25px;
                line-height: 50px;
                text-align: center;
                color: #ffffff;
                font-size: 24px;
                margin-top: 30px;
                margin-left: 20px;
            }

            .w160 {
                width: 160px;
            }
        }

        .preContentWrapper.mb-18 {
            padding-bottom: 18px;
        }

        .imageBox {
            display: flex;
            flex-wrap: wrap;

            >div {
                position: relative;

                >span {
                    position: absolute;
                    display: inline-block;
                    width: 20px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    left: 0;
                    top: 0;
                    background: #ffffff;
                    color: red;
                    font-size: 16px;
                }

                .flag-img {
                    position: absolute;
                    left: 16px;
                    width: 32px;
                    height: 48px;
                }

                .flag-num {
                    position: absolute;
                    left: 16px;
                    top: 0;
                    width: 32px;
                    height: 48px;
                    font-size: 16px;
                    color: #fff;
                    text-align: center;
                    margin-top: 8px;
                }
            }

            img {
                // border: 1px solid #ccc;
            }

            .white-box {
                width: 276px;
                height: 379px;
                background-color: #fff;
            }

            .oneImg {
                width: 630px;
                height: 296px;
            }

            .twoImg {
                width: 49%;
                height: 200px;
                padding: 5px;
            }

            .threeImg {
                width: 33%;
                height: 200px;
                padding: 5px;
            }

            .send-img-btn {
                position: absolute;
                left: 50%;
                bottom: 16px;
                transform: translate(-50%, 0);
                width: 136px;
                height: 50px;
                background: #2fd0d5;
                border-radius: 25px;
                text-align: center;
                color: #ffffff;
                font-size: 24px;
                line-height: 50px;
            }
        }

        .whiteSpace {
            font-size: 28px;
            min-height: 40px;
            color: #66757f;
            display: -webkit-box;
            overflow: hidden;
            white-space: pre-wrap;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .list-item-vertical .whiteSpace {
            -webkit-line-clamp: 1;
        }

        .wordAndImage {
            width: 630px;
            min-height: 107px;
            background: #fafafe;
            border-radius: 4px;
            padding: 18px 20px;

            >div {
                display: flex;

                // border: 1px solid #ccc;
                img {
                    width: 60px;
                    height: 60px;
                    margin-right: 20px;
                }

                .wordWrapper {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    width: 160px;

                    .title {
                        font-size: 24px;
                        color: #35434c;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-bottom: 10px;
                    }

                    .desc {
                        word-wrap: break-word;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        overflow: hidden;
                        color: #c0c0c0;
                        font-size: 20px;
                    }
                }
            }
        }

        .wordAndImage {
            >div {
                border: 0;
                align-items: center;
            }
        }

        .videoWrapper {
            >div {
                width: 100%;
                height: 200px;
                overflow: hidden;
            }

            .videoBox {
                position: relative;
                border-radius: 5px;
                width: 630px;
                height: 296px;

                &::after {
                    content: "";
                    position: absolute;
                    background: #333333;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    opacity: 0.5;
                }

                >span {
                    display: inline-block;
                    width: 50px;
                    height: 50px;
                    // background: url("../../../../assets/img/play.png") no-repeat;
                    background-size: cover;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }

                .video-img {
                    width: 630px;
                    height: 296px;
                }

                .player-icon {
                    width: 90px;
                    height: 90px;
                    position: absolute;
                    z-index: 1;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
            }

            video {
                height: 200px;
            }
        }

        .appWrapper {
            width: 466px;
            height: 530px;
            border-radius: 8px;
            box-shadow: 0px 2px 12px 0px rgba(209, 207, 207, 0.32);
            background: #ffffff;
            padding: 24px;

            .header {
                display: flex;
                align-items: center;

                img {
                    width: 40px;
                    height: 40px;
                }

                span {
                    font-size: 24px;
                    padding-left: 10px;
                    color: #a0acb5;
                }
            }

            .footer {
                display: flex;
                align-items: center;
                padding-top: 7px;
                border-top: 1px solid #d7d7d7;

                img {
                    width: 20px;
                    height: 20px;
                }

                span {
                    font-size: 24px;
                    padding-left: 10px;
                    color: #35434c;
                }
            }

            .mainImg {
                width: 418px;
                height: 335px;
                margin: 12px 0 20px 0;

                img {
                    width: 418px;
                    height: 335px;
                }
            }
        }

        .audioImage,
        .filesWrapper {
            width: 630px;
            height: 70px;
            padding: 17px 20px;
            border-radius: 4px;
            background: #fafafe;

            >div {
                display: flex;
                align-items: center;

                .file-icon {
                    width: 34px;
                    height: 34px;
                    margin-right: 10px;
                }

                .title {
                    width: 410px;
                    font-size: 24px;
                    font-weight: 400;
                    color: #4375c9;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                .size {
                    min-width: 133px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #a0acb5;
                }
            }
        }
    }

    .definition-popup-box {
        width: 630px;
        min-height: 682px;
        background: #ffffff;
        border-radius: 16px;

        .definition-show-box {
            .definition-head {
                width: 630px;
                height: 116px;
                background: url(https://staticwecom.beautyfarm.com.cn/wecome_activity/rule-header-sck.png) 100% no-repeat;
                background-size: 100% 100%;
                font-size: 36px;
                font-weight: 700;
                color: #35434c;
                text-align: center;
                padding-top: 42px;
            }

            .definition-content {
                padding: 10px 40px 80px 40px;
                height: 556px;
                overflow-y: auto;

                .statistics-color {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    background: #a3b3d0;
                }

                .member-statistics-name {
                    height: 28px;
                    font-size: 28px;
                    font-weight: 700;
                    color: #35434c;
                    line-height: 28px;
                    margin-left: 10px;
                }

                .statistics-store {
                    height: 36px;
                    font-size: 24px;
                    color: #66757f;
                    line-height: 36px;
                    margin-top: 20px;
                }

                .mt {
                    margin-top: 50px;
                }

                .dot {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    background: #a3b3d0;
                    margin-right: 10px;
                }

                .definition-title {
                    font-size: 28px;
                    font-weight: 700;
                    color: #35434c;
                }

                .definition-name-box {
                    margin-top: 20px;
                }

                .definition-name {
                    font-size: 24px;
                    color: #66757f;
                    margin-bottom: 24px;
                }

                .definition-remark {
                    font-size: 24px;
                    color: #66757f;
                    margin-top: 52px;
                }
            }
        }
    }

    .contact-box {
        z-index: 999;
        position: fixed;
        right: 30px;
        bottom: 343px;
        min-width: 86px;
        height: 386px;
        background: #333f48;
        border-radius: 71px;
        opacity: 0.8;
        align-items: center;
        padding: 20px 12px 20px 14px;

        .icon-item {
            width: 46px;
            height: 46px;
            margin-bottom: 5px;
        }

        .contact-name {
            font-size: 20px;
            color: #ffffff;
            line-height: 33px;
            text-align: center;
            width: 60px;
            height: 36px;
            border-radius: 18px;
            margin-bottom: 21px;
        }

        .contact-name.active {
            background: #56c8cc;
        }

        .icon-arrow img {
            width: 20px;
            height: 20px;
        }
    }

    .chat-box {
        width: 86px;
        height: 60px;
        background: #333f48;
        border-radius: 71px;
        opacity: 0.8;
        z-index: 999;
        position: fixed;
        right: 30px;
        bottom: 343px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    :deep(.van-popup) {
        overflow-y: visible !important;
    }

    :deep(.van-popup__close-icon--top-right) {
        top: 105% !important;
        right: 45% !important;
    }

    :deep(.definition-show-box .van-icon__image) {
        width: 56px !important;
        height: 56px !important;
    }

    :deep(.search .van-search) {
        padding: 0;
    }

    :deep(.search .van-search .van-cell) {
        background-color: #ffffff !important;
        border-radius: 6px;
        font-size: 28px;
        display: flex;
        align-items: center;
    }

    :deep(.search .van-icon) {
        font-size: 28px;
    }

    :deep(.search .van-search__content) {
        padding-left: 0 !important;
    }

    :deep(.van-search .van-cell) {
        padding: 15px 20px;
    }

    :deep(.search .van-icon__image) {
        width: 28px;
        height: 28px;
    }

    :deep(.van-field__left-icon) {
        color: #c8c9cc !important;
        width: 28px;
        height: 28px;
        margin-right: 20px;
    }

    :deep(#inner-tab .van-tabs__wrap) {
        padding-right: 40px;
    }

    :deep(#inner-tab .van-tabs .van-tab--active > .van-ellipsis) {
        height: 70px !important;
        line-height: 70px;
        border-radius: 0 !important;
        color: #35434c !important;
    }

    :deep(#inner-tab .van-tabs .van-tabs__nav) {
        min-width: 0;
        padding: 0 0;
        padding-bottom: 24px;
        background-color: transparent !important;
    }

    :deep(#inner-tab .van-tabs .van-tab) {
        padding: 0 !important;
        margin-right: 50px;
    }

    :deep(#inner-tab .van-tabs .van-tab.van-tab--active .van-tab__text) {
        font-weight: 400 !important;
        font-weight: normal;
    }

    :deep(.van-dropdown-menu) {
        font-weight: 400;
    }

    :deep(.van-dropdown-menu__bar) {
        height: 60px;
        box-shadow: none;
        background-color: transparent;
    }

    :deep(.van-dropdown-menu__title) {
        color: #35434c;
        font-size: 28px;
        padding: 0;
        padding-right: 10px;
    }

    :deep(.van-dropdown-item__content) {
        border-radius: 0px 0px 36px 36px;
    }

    :deep(.van-dropdown-menu__title::after) {
        border-color: transparent transparent #35434c #35434c !important;
    }

    :deep(.van-empty__description) {
        width: 300px;
        color: #c0c0c0;
        font-size: 24px;
    }

    :deep(.empty .van-empty) {
        padding: 0;
    }
</style>
